import { TEAM_TYPES } from 'common/constants/constants';
import { TEAMS_CONFIG, CONFIG_ACTIONS } from './constants';

export const getPageConfig = ({ type, team }) => {
  const { id, isSynced = false } = team;
  const isEdit = !!id;
  const action = isEdit ? CONFIG_ACTIONS.EDIT : CONFIG_ACTIONS.ADD;

  return {
    pageTitle: TEAMS_CONFIG[action][type].title,
    githubNameFieldTitle: TEAMS_CONFIG[type].FORM_FIELDS.GITHUB_NAME.title,
    nameFieldTitle: TEAMS_CONFIG[type].FORM_FIELDS.NAME.title,
    parentGroupFieldTitle: TEAMS_CONFIG.FORM_FIELDS.PARENT_GROUP.title,
    nestedTeamsFieldTitle: TEAMS_CONFIG.FORM_FIELDS.NESTED_TEAMS.title,
    colorFieldTitle: TEAMS_CONFIG.FORM_FIELDS.COLOR.title,
    initialsFieldTitle: TEAMS_CONFIG.FORM_FIELDS.INITIALS.title,
    nameError: TEAMS_CONFIG[type].FORM_FIELDS.NAME.error,
    initialsError: TEAMS_CONFIG[type].FORM_FIELDS.INITIALS.error,
    isSynced,
    showNestedTeams: TEAMS_CONFIG[type].showNestedTeams,
    showWithHistory: TEAMS_CONFIG[action][type].showWithHistory && !isSynced,
    showWithoutBackfill:
      TEAMS_CONFIG[action][type].showWithoutBackfill && !isSynced,
    isDirectContributorsCollapsable: type === TEAM_TYPES.GROUP,
    isDirectContributorsTitleClickable: type === TEAM_TYPES.GROUP,
    isEdit,
    mandatoryDirectContributors: type === TEAM_TYPES.TEAM
  };
};

export const submit = ({
  onSubmit,
  isEdit,
  isSynced,
  initialTeamProps,
  teamFormValues
}) => {
  if (isEdit) {
    const { contributor_ids: initialContributorIds = [] } = initialTeamProps;
    const { contributor_ids: newContributorIds = [] } = teamFormValues;
    const contributorsToRemove = initialContributorIds.filter(
      contributorId => !newContributorIds.includes(contributorId)
    );
    const contributorsToAdd = newContributorIds.filter(
      contributorId => !initialContributorIds.includes(contributorId)
    );

    return onSubmit({
      initialTeamProps,
      teamFormValues,
      contributorsToAdd,
      contributorsToRemove,
      isEdit: true,
      isSynced
    });
  }
  onSubmit({
    teamFormValues,
    isEdit
  });
};
